import Component from '../component';

export default class SortableTable extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.resource = this.$element.data('resource');
    this.bindEvents();
  }

  bindEvents() {
    this.$element.sortable({
      items: '.sortableTable-row',
      cursor: 'move',
      axis: 'y',
      helper: (_, ui) => this.handleSortableHelper(ui),
      stop: (_, ui) => this.handleSortableStop(ui),
    });
  }

  unbindEvents() {
    this.$element.sortable('destroy');
  }

  handleSortableHelper(ui) {
    ui.children().each(function () {
      $(this).width($(this).width());
    });

    return ui;
  }

  handleSortableStop(ui) {
    this.handleSort(ui.item);
    this.updatePositions();
  }

  handleSort(item) {
    const data = {
      [this.resource]: {
        position: $(item).prevAll('.sortableTable-row').length,
      },
    };

    $.ajax({
      url: $(item).data('url'),
      type: 'PUT',
      data,
    });
  }

  updatePositions() {
    const $rows = this.$element.find('.sortableTable-row');

    $rows.each((index, item) => {
      $(item)
        .find('.sortableTable-row-position')
        .html(index + 1);
    });
  }
}
